// ##### 24-08-10 Komarov
import React from 'react';
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const TopHotelsTitle = ({ fontSize }) => {
  // ##### Komarov 2025-08-05
  const sloganText = useSelector(state => state.pagesRedux[state.language]?.ArkturTopHotels || '');

  return (
    <h2
      data-component="TopHotelsTitle"
      style={{
        padding: '0.2em',
        margin: 'auto',
        color: 'rgb(122,6,8)',
        fontSize,
        fontFamily: 'Arial',
        fontWeight: 'bold',
      }}
    >
      {sloganText}
    </h2>
  );
};

export default TopHotelsTitle;
